// extracted by mini-css-extract-plugin
export default {"root":"switch-organization_root__7zcse","header":"switch-organization_header__JMUDn","organizations":"switch-organization_organizations__UUc+G"};